/* Ott-common */
import { createAEMService } from '@dtvgo/aem-service';

/* Utils */
import { WEB_URL } from '../utils/env';

const host = import.meta.env.NODE_ENV === 'development' ? '' : WEB_URL;

const aemService = createAEMService({
  host,
});

export default aemService;
